<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("LakalaAccount.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("LakalaAccount.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <ValidationObserver ref="observer">
          <v-form>
            <v-card-text>
              <v-container>
                <!-- 账户号 -->
                <v-row align="center" v-if="!isNew">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("LakalaAccount.Fields.lakala_member_no") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    {{ lakalaAccount && lakalaAccount.lakala_member_no ? lakalaAccount.lakala_member_no : "" }}
                  </v-col>
                </v-row>
                <!-- 公司名称 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("LakalaAccount.Fields.company_name") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('LakalaAccount.Fields.company_name')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="lakalaAccount.company_name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'company_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ lakalaAccount.company_name }}
                  </v-col>
                </v-row>
                <!-- 账户编码 -->
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("LakalaAccount.Fields.out_member_no") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('LakalaAccount.Fields.out_member_no')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="lakalaAccount.out_member_no"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'out_member_no'
                            )
                            .concat(errors)
                        "
                        :disabled="(lakalaAccount && lakalaAccount.lakala_member_no) ? true : false"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ lakalaAccount.out_member_no }}
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </ValidationObserver>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", []) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&  lakalaAccount
                  && lakalaAccount.actions
                  && lakalaAccount.actions.lkl_edit_user
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !lakalaAccount.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", []) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  (isNew || lakalaAccount
                  && lakalaAccount.actions
                  && lakalaAccount.actions.lkl_edit_user)
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !lakalaAccount.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", []) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Required from "@/components/plugins/Required";
import ThirdAccountInfo from "@/api/third-account-info";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "LakalaAccountDetail",

  props: ["value", "mode"],

  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    lakalaAccount: {},
    serverErrors: [],
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            let submitData = this.getSubmitData();
            if (!this.isNew) {
              ThirdAccountInfo.editLklUser(submitData).then(
                function (response) {
                  if (response.date.status.isOK()) {
                    this.$emit("save", submitData);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                  } else if (response.data.error && response.data.error.data && "ERR333" == response.data.error.code) {
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.serverErrors = response.data.error.data;
                  }
                }.bind(this)
              ).catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            } else {
              ThirdAccountInfo.addLklUser(submitData).then(
                function (response) {
                  if (response.date.status.isOK()) {
                    this.$emit("save", submitData);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                  } else if (response.data.error && response.data.error.data && "ERR333" == response.data.error.code) {
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.serverErrors = response.data.error.data;
                  }
                }.bind(this)
              ).catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
            }
            this.$emit("save", submitData);
            this.$emit("mode", null);
            this.$emit("input", null);
            this.$refs.observer.reset();
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    getSubmitData() {
      let submit = {};
      submit.company_name = this.lakalaAccount.company_name;
      submit.out_member_no = this.lakalaAccount.out_member_no;
      if (this.lakalaAccount.id) {
        submit.id = this.lakalaAccount.id;
      }
      return JSON.parse(JSON.stringify(submit));
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          ThirdAccountInfo.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.lakalaAccount = response.data.third_account;
                this.lakalaAccount.out_member_no = this.lakalaAccount.lakala_out_member_no
              }
            }.bind(this)
          );
        } else {
          // 初始化默认值
          this.lakalaAccount = {
            company_name: "",
            out_member_no: ""
          }
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>